import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "select-material" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["value"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "select-highlight" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "select-bar" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "select-label" }, "施設選択", -1)

import { computed, ref, watch, withDefaults } from 'vue';
import { ListOption } from '@/utility/ListOptions';
import { confirm } from '@/utility/messages';


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectBase',
  props: {
    modelValue: null,
    baseOpts: null,
    edited: { type: Boolean },
    dataName: { default: 'データ' }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: unknown): void;
  (e: 'change'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: unknown, baseOpts: ListOption<string>[], edited?: boolean, dataName: string }




const model = computed({
  get: () => props.modelValue as string,
  set: value => emit('update:modelValue', value),
});
watch(() => [props.modelValue], setComponentModel);
function setComponentModel() {
  baseCode.value = model.value as string;
}

const baseCode = ref('');

async function changeBCode(event: Event, editedMovement: boolean | undefined, preBCode: string) {
  if (!(event.target instanceof HTMLSelectElement) || event.target.value.length === 0) {
    return;
  }

  if (editedMovement) {
    const res = await confirm(props.dataName + 'が保存されていません。保存せず拠点を変更しますか？', 'width: auto');
    if (!res) {
      baseCode.value = preBCode;
      return;
    }
  }

  baseCode.value = event.target.value;
  model.value = baseCode.value;
}

function init() {
  setComponentModel();
}

init();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("select", {
      value: baseCode.value,
      class: "select-text",
      onChange: _cache[0] || (_cache[0] = ($event: any) => (changeBCode($event, props.edited, _unref(model)), emit('change')))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.baseOpts, (opt) => {
        return (_openBlock(), _createElementBlock("option", {
          key: opt.text,
          value: opt.value
        }, _toDisplayString(opt.text), 9, _hoisted_3))
      }), 128))
    ], 40, _hoisted_2),
    _hoisted_4,
    _hoisted_5,
    _hoisted_6
  ]))
}
}

})